import { BulkActionPanel } from 'components/BulkActionPanel'
import Modal from 'components/Modal'
import Toast from 'components/Toast'
import SelectionProvider from 'providers/SelectionProvider'
import SplitWatchProvider from 'providers/SplitWatchProvider'
import styled from 'styled-components'
import type { ChildProps } from 'types'
import { Nav } from './Navigation'

const Layout = ({ children }: ChildProps): JSX.Element => {
  return (
    <SelectionProvider>
      <SplitWatchProvider>
        <Modal />
        <Nav />
        <MainContainer id={'MainContainer'}>{children}</MainContainer>
        <BulkActionPanel />
        <Toast />
      </SplitWatchProvider>
    </SelectionProvider>
  )
}

const MainContainer = styled.div`
  height: calc(100vh - 3.75rem);
  overflow-y: scroll;
`

export default Layout
